import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth'
import missions from './mission'
import forms from './forms'
import asterx from './asterx'
import screening from './screening'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    missions,
    forms,
    asterx,
    screening
  }
})
